<template>
  <div v-show="show" class="warning-comment">
    <h4>Внимение!</h4>
    <div v-for="(rule, key) in rules" :key="key">
      <p v-if="shouldShowWarning(rule)">{{ rule.message }}</p>  
    </div>
 
  </div>
</template>

<script>
import { useStore } from 'vuex'
import { computed,ref } from 'vue'

export default {
  name: 'executor-warning',
  props: ['executor'],
  setup(props) {
    const store = useStore()
    const security_options = computed(()=>store.state.apiStorage.options.security)
    const show = ref(false)
    const carSecurity = props.executor.car.security_info[0];
    const companySecurity = props.executor.company.security_info[0];
    const driverSecurity = props.executor.driver.security_info[0];
    const car = props.executor.car;
    const company = props.executor.company;
    const manager = props.executor.manager;

    const checkYearRegistry = (val1,val2)=>{
      if(val1 && val2){
        return val1.substr(0, 4)>val2  
      }
    }

    const rules = [
      
      {
        condition: manager.ati_manager_status !== 'Полное совпадение',
        message: manager.ati_manager_status,
      },
      {
        condition: companySecurity.ati_company_orgn_num && company.ogrn.toString() !== companySecurity.ati_company_orgn_num.toString(),
        message: 'ОГРН не совпадает с АТИ',
      },
      {
        condition:companySecurity.dadata_inn_ogrn && company.ogrn.toString() !== companySecurity.dadata_inn_ogrn.toString(),
        message: 'ОГРН не совпадает с Налоговой',
      },
      {
        condition:driverSecurity.dadata_is_end &&  driverSecurity.dadata_passport_is_verify == false,
        message: 'Водитель: Требуется повторная проверка паспорта',
      },
      {
        condition:carSecurity.avtocod_is_end && carSecurity.avtocod_policy_owner !== company.inn,
        message: 'Владельц полиса авто не совпадает с ИНН компании.',
      },
      {
        condition:carSecurity.avtocod_is_end && carSecurity.avtocod_owner_ogrn && carSecurity.avtocod_owner_ogrn.toString() !== company.ogrn.toString(),
        message: 'ОГРН владельца авто не совпадает с компанией.',
      },
      {
        condition:carSecurity.avtocod_is_end && carSecurity.avtocod_identifiers_reg_num !== car.number,
        message: 'Не актуальный номер авто',
      },
      {
        condition:carSecurity.avtocod_is_end && carSecurity.avtocod_wanted_is_wanted == true,
        message: 'Автомобиль в розыске ',
      },
      {
        condition:carSecurity.avtocod_is_end && carSecurity.avtocod_identifiers_release_year <= security_options.value.min_release_year,
        message: 'Год выпуска старше допустимого '+security_options.value.min_release_year,
      },
      {
        condition:carSecurity.avtocod_is_end && carSecurity.avtocod_owner_days_passed <= security_options.value.min_year_passed*365,
        message: 'Короткий период владения дней: '+carSecurity.avtocod_owner_days_passed
      },
      {
        condition:checkYearRegistry(companySecurity.dadata_inn_registration_date,security_options.value.min_company_registration_year),
        message: 'Компания не проходит по дате регистрации'
      },
    ];

    const shouldShowWarning = rule => {
      if(rule.condition && !show.value){
        show.value = true
      }
      return rule.condition;
    };

    return {
      security_options,
      carSecurity,
      companySecurity,
      rules,
      shouldShowWarning,
      show
    };
  },
};
</script>

<style scoped>
.warning-comment{
  color: red;
  font-size: 14px;
  max-width: 400px;
}
</style>
